import {
  WorkflowTaskTemplate as OctopusWorkflowTaskTemplate,
  WorkflowTaskTemplateFieldOptionsResponse,
} from '../models';
import {
  WorkflowTaskTemplateFieldOption,
  WorkflowTaskTemplateProperty,
} from '../../../models';
import { Mapper } from '../../../mappers';
import { ConfigurationMapper } from './configuration';

export class WorkflowTaskTemplatePropertyMapper extends Mapper<
  OctopusWorkflowTaskTemplate[],
  WorkflowTaskTemplateProperty[]
> {
  from(source: OctopusWorkflowTaskTemplate[]): WorkflowTaskTemplateProperty[] {
    return source.map((item) => ({
      key: item.Key ?? '',
      subject: item.Subject ?? '',
      workflowKey: item.WorkflowKey ?? '',
      sequence: item.Sequence ?? 0,
      icon: item.IconType?.Value ?? 0,
      dateOffsetUnit: item.DateOffsetUnit ?? 1,
      dateOffsetValue: item.DateOffsetValue ?? 1,
      alarmOffsetUnit: item.AlarmOffsetUnit ?? 1,
      alarmOffsetValue: item.AlarmOffsetValue ?? 1,
      priority: item.Priority?.Value ?? '',
      category: item.Category?.Value ?? '',
      time: item.Time ?? '',
      assignedToExpression: item.AssignedToExpression?.DisplayValue ?? '',
    }));
  }
}

export class WorkflowTaskTemplateFieldOptionsMapper extends ConfigurationMapper<
  WorkflowTaskTemplateFieldOptionsResponse,
  WorkflowTaskTemplateFieldOption
> {
  from(
    source: WorkflowTaskTemplateFieldOptionsResponse,
  ): WorkflowTaskTemplateFieldOption {
    const workflowTaskTemplate = source.WorkflowTaskTemplate?.FieldOptions;

    return {
      priority:
        workflowTaskTemplate?.Priority?.map(this.mapKeyAndDisplay) ?? [],
      category:
        workflowTaskTemplate?.Category?.map(this.mapKeyAndDisplay) ?? [],
      alarmOffsetUnit:
        workflowTaskTemplate?.AlarmOffsetUnit?.map(this.mapKeyAndDisplay) ?? [],
      dateOffsetUnit:
        workflowTaskTemplate?.DateOffsetUnit?.map(this.mapKeyAndDisplay) ?? [],
      assignedToExpression:
        workflowTaskTemplate?.AssignedToExpression?.map(
          this.mapKeyAndDisplay,
        ) ?? [],
    };
  }
}
